import { render, staticRenderFns } from "./FaceDirectionResultEffectIconDirection.vue?vue&type=template&id=2551474e&scoped=true&"
import script from "./FaceDirectionResultEffectIconDirection.vue?vue&type=script&lang=ts&"
export * from "./FaceDirectionResultEffectIconDirection.vue?vue&type=script&lang=ts&"
import style0 from "./FaceDirectionResultEffectIconDirection.vue?vue&type=style&index=0&id=2551474e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2551474e",
  null
  
)

export default component.exports